// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__235xx","question":"Question_question__ACbku","description":"Question_description__2FY3f"};